module.exports = __webpack_public_path__ + "media/images/sindma/footer-logo-gba-7fffe023568743894d916a257278d87c.jpeg";